
function isObject(value) {
    return typeof value === 'object' && value !== null && value.constructor === Object;
}


function isCallable(func) {
  return typeof func === 'function' || func instanceof Function;
}

export { isCallable, isObject}